import React from "react";

const AnimatedBackground = () => (
  <svg viewBox="0 0 1440 400" width="100%" height="100%" style={{position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none'}}>
    <defs>
      <linearGradient id="waveGradient1" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#7ecfff" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#b3c2f2" stopOpacity="0.3" />
      </linearGradient>
      <linearGradient id="waveGradient2" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#b3c2f2" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#7ecfff" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient id="waveGradient3" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#a0bfff" stopOpacity="0.5" />
        <stop offset="100%" stopColor="#b3c2f2" stopOpacity="0.15" />
      </linearGradient>
    </defs>
    {/* Верхние волны */}
    <path fill="none" stroke="url(#waveGradient1)" strokeWidth="3.5" opacity="0.55">
      <animate attributeName="d" dur="12s" repeatCount="indefinite"
        values="M0,30 C400,0 1040,80 1440,30;M0,60 C420,20 1020,100 1440,60;M0,30 C400,0 1040,80 1440,30" />
    </path>
    <path fill="none" stroke="url(#waveGradient2)" strokeWidth="3" opacity="0.45">
      <animate attributeName="d" dur="14s" repeatCount="indefinite"
        values="M0,80 C600,40 800,120 1440,80;M0,100 C620,60 820,140 1440,100;M0,80 C600,40 800,120 1440,80" />
    </path>
    {/* Центральные волны */}
    <path fill="none" stroke="url(#waveGradient3)" strokeWidth="4" opacity="0.5">
      <animate attributeName="d" dur="10s" repeatCount="indefinite"
        values="M0,160 C600,200 800,100 1440,160;M0,180 C620,220 820,120 1440,180;M0,160 C600,200 800,100 1440,160" />
    </path>
    <path fill="none" stroke="url(#waveGradient1)" strokeWidth="3.5" opacity="0.6">
      <animate attributeName="d" dur="8s" repeatCount="indefinite"
        values="M0,200 C400,400 1040,0 1440,200;M0,220 C420,380 1020,40 1440,220;M0,200 C400,400 1040,0 1440,200" />
    </path>
    <path fill="none" stroke="url(#waveGradient2)" strokeWidth="3" opacity="0.5">
      <animate attributeName="d" dur="11s" repeatCount="indefinite"
        values="M0,260 C360,320 1080,80 1440,260;M0,280 C380,340 1060,100 1440,280;M0,260 C360,320 1080,80 1440,260" />
    </path>
    {/* Нижние волны */}
    <path fill="none" stroke="url(#waveGradient3)" strokeWidth="4" opacity="0.6">
      <animate attributeName="d" dur="13s" repeatCount="indefinite"
        values="M0,320 C600,350 800,400 1440,370;M0,340 C620,370 820,400 1440,390;M0,320 C600,350 800,400 1440,370" />
    </path>
    <path fill="none" stroke="url(#waveGradient1)" strokeWidth="3.5" opacity="0.5">
      <animate attributeName="d" dur="15s" repeatCount="indefinite"
        values="M0,370 C400,390 1040,390 1440,370;M0,390 C420,400 1020,400 1440,390;M0,370 C400,390 1040,390 1440,370" />
    </path>
    <path fill="none" stroke="url(#waveGradient2)" strokeWidth="3" opacity="0.45">
      <animate attributeName="d" dur="17s" repeatCount="indefinite"
        values="M0,395 C200,400 1240,400 1440,395;M0,400 C220,400 1220,400 1440,400;M0,395 C200,400 1240,400 1440,395" />
    </path>
    <path fill="none" stroke="url(#waveGradient3)" strokeWidth="2.5" opacity="0.35">
      <animate attributeName="d" dur="19s" repeatCount="indefinite"
        values="M0,398 C600,399 800,400 1440,398;M0,400 C620,400 820,400 1440,400;M0,398 C600,399 800,400 1440,398" />
    </path>
  </svg>
);

export default AnimatedBackground; 